/**
 * Cleans the generated email body by removing excessive <br> tags
 *
 * NOTE: The backend sends the email in a format that is not very compatible with our TipTap editor.
 * It includes <br> tags between paragraphs which creates excessive spacing in the editor.
 *
 * TODO: Consider updating the backend to return HTML that's more compatible with TipTap editor format.
 *
 * @param body - The raw HTML body from the API
 * @returns Cleaned HTML body with excessive br tags removed
 */
export const cleanGeneratedEmailBody = (body: string): string => {
    // Remove standalone <br> tags between paragraphs
    return body.replace(/<\/p><br><p>/g, '</p><p>');
};
